import styled from 'styled-components';
import { Button } from 'antd';

export const InternalUsersManagementHeader = styled.header`
  display: flex;
  flex-direction: column;

  width: 97%;
  margin: 1rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto;
    max-width: initial;
    padding: 0;
  }

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-bottom: 1rem;

  & > div.content {
    display: flex;
    flex-direction: column;

    width: 97%;
    margin: 1rem auto 0 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: initial;
    }
  }
`;

export const InternalUsersTableContainer = styled.div`
  width: 100%;
  border-radius: 0.25rem;
`;

export const AddUserButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const AddUserContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  margin-bottom: 1rem;
`;
